/*LIBRARY*/
import {
  useEffect,
  // useRef,
  // useCallback
} from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import MAP_CONTROL from "../libre_draw/MAP_CONTROL";
import DRAW_GEO from "../libre_draw/DRAW_GEO";
import LEGEND_PARENT from "../map_legend/LEGEND_PARENT";
import POPUP_EDITOR from "../libre_popup/POPUP_EDITOR";
import LAYER_FEATURE_SELECTED from "./LAYER_FEATURE_SELECTED";
import LAYER_GEO from "./LAYER_GEO";
import MARKER_GEO from "./MARKER_GEO";
import LAYER_HEATMAP from "./LAYER_HEATMAP";
import LAYER_GPS from "./LAYER_GPS";
import LAYER_TOOLBOX from "./LAYER_TOOLBOX";
import LAYER_INSIGHT from "./LAYER_INSIGHT";
import SYMBOL_GEO from "./SYMBOL_GEO";
import M_S_LOADING from "../libre_marker_sini/M_S_LOADING";
import LAYER_S_CENTER from "../libre_layer_sini/LAYER_S_CENTER";
import LAYER_S_POI from "../libre_layer_sini/LAYER_S_POI";
import LAYER_S_POI_SURVEY_1 from "../libre_layer_sini/LAYER_S_POI_SURVEY_1";
import LAYER_S_DEMOGRAPHY_LIST from "../libre_layer_sini/LAYER_S_DEMOGRAPHY_LIST";
import LAYER_S_ISOCHRONE from "../libre_layer_sini/LAYER_S_ISOCHRONE";
import LAYER_S_FLOOD_NEIGHBOR from "../libre_layer_sini/LAYER_S_FLOOD_NEIGHBOR";
import LAYER_S_LANDSLIDE_NEIGHBOR from "../libre_layer_sini/LAYER_S_LANDSLIDE_NEIGHBOR";
import LAYER_S_LANDVALUE from "../libre_layer_sini/LAYER_S_LANDVALUE";
import LAYER_S_LANDVALUE_NEIGHBOR from "../libre_layer_sini/LAYER_S_LANDVALUE_NEIGHBOR";
import LAYER_S_LANDZONE_NEIGHBOR from "../libre_layer_sini/LAYER_S_LANDZONE_NEIGHBOR";
import LAYER_S_LANDZONE from "../libre_layer_sini/LAYER_S_LANDZONE";
import LAYER_S_RDTR_NEIGHBOR from "../libre_layer_sini/LAYER_S_RDTR_NEIGHBOR";
import LAYER_S_RDTR_ONE from "../libre_layer_sini/LAYER_S_RDTR_ONE";
import LAYER_S_TSUNAMI_NEIGHBOR from "../libre_layer_sini/LAYER_S_TSUNAMI_NEIGHBOR";
import LAYER_S_POI_PROPERTY from "../libre_layer_sini/LAYER_S_POI_PROPERTY";
import LAYER_SEARCH from "./LAYER_SEARCH";
import LAYER_TOOLBOX_GRID from "./LAYER_TOOLBOX_GRID";
import LAYER_FLOOD_SERVER from "./LAYER_FLOOD_SERVER";
import LAYER_EXTRUDE_DEM from "./LAYER_EXTRUDE_DEM";
import LAYER_EXTRUDE_FLOOD from "./LAYER_EXTRUDE_FLOOD";
import FLOOD_NEW from "../sidebar_map_right/FLOOD_NEW";
import LAYER_PROPERTY_APP from "../libre_layer_sini/LAYER_PROPERTY_APP";
import LAYER_ACTIVITIES_APP from "../libre_layer_sini/LAYER_ACTIVITIES_APP";
import LIBRE_GLB from "./LIBRE_GLB";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_sini } from "../../App/actions/sini_v2";
import { get_features_by_bound } from "../../App/actions/get_features_by_bound";

import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

const { Map } = maplibregl;

/*CONST*/
const basemap_url = process.env.REACT_APP_MAPID_BASEMAP;
const basemap_key = process.env.REACT_APP_BASEMAP_KEY;
// const max_zoom = 10;
// const delay_bounding_box = 500;

const MAP_COMPONENT = ({
  auth,
  layer,
  project,
  properties,
  is_editable,
  set_value_layer,
  set_value_sini,
  get_features_by_bound,
}) => {
  // const fetch_timeout = useRef(null);

  const { map_object } = layer;

  // const on_get_features_by_bound = useCallback(() => {
  //   const { map_object, layer_id_bound, geo_layer_list } = layer;
  //   if (map_object && layer_id_bound?.length > 0) {
  //     const zoom_level = map_object.getZoom();
  //     if (zoom_level >= max_zoom) {
  //       const { geo_project } = project;
  //       const geo_layer = geo_layer_list.find(
  //         (item) => item?.geo_layer?._id === layer_id_bound[0],
  //       );
  //       const fields = geo_layer?.geo_layer?.fields || [];
  //       const bounds = map_object.getBounds();
  //       const params = {
  //         bounds,
  //         geo_layer_id: layer_id_bound[0],
  //         geo_project_id: geo_project._id,
  //         fields: fields,
  //       };
  //       get_features_by_bound(params);
  //     }
  //   }
  // }, [layer, project, get_features_by_bound]);

  // This effect handles the one-time initialization of the map.
  useEffect(() => {
    const primary_style = `${basemap_url}/styles/street-2d-building/style.json?key=${basemap_key}`;

    const initialize_map = () => {
      const map_object = new Map({
        container: "map_object",
        pixelRatio: Math.min(window.devicePixelRatio, 2),
        style: primary_style,
        center: [118.72762419354456, -0.2055368192132505],
        zoom: 3.7,
        minZoom: 0,
        maxZoom: 24,
        maxPitch: 75,
        attributionControl: false,
        canvasContextAttributes: { antialias: false },
      });

      map_object.addControl(
        new maplibregl.AttributionControl({
          compact: properties.is_mobile,
        }),
        "bottom-left",
      );
      set_value_layer({
        key: "map_object",
        value: map_object,
      });
    };

    initialize_map();

    return () => {
      set_value_layer({ key: "map_object", value: null });
      set_value_layer({ key: "draw_object", value: null });
      set_value_layer({ key: "basemap_offline", value: false });
      set_value_sini({ key: "sini_v2_list", value: [] });
      set_value_sini({ key: "ai_parent_detail_list", value: [] });
      set_value_sini({ key: "ai_parent_list", value: [] });

      if (map_object) {
        map_object.remove();
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.version, set_value_layer, set_value_sini, properties.is_mobile]);

  // useEffect(() => {
  //   const map_object = layer.map_object;
  //   if (!map_object) {
  //     return;
  //   }

  //   const setup_map_listeners = (map_instance) => {
  //     const zoomHandler = () => {
  //       const zoom_level = map_instance.getZoom();
  //       // Always clean up move listeners on zoom to avoid duplicates
  //       map_instance.off("move");
  //       map_instance.off("moveend");

  //       if (zoom_level < max_zoom) {
  //         // Listeners are already off, do nothing.
  //       } else {
  //         // If zoom is high enough, re-attach move listeners
  //         map_instance.on("move", () => {
  //           clearTimeout(fetch_timeout.current);
  //         });
  //         map_instance.on("moveend", () => {
  //           clearTimeout(fetch_timeout.current);
  //           fetch_timeout.current = setTimeout(() => {
  //             if (map_instance.getZoom() >= max_zoom) {
  //               on_get_features_by_bound();
  //             }
  //           }, delay_bounding_box);
  //         });
  //       }
  //     };

  //     map_instance.on("zoom", zoomHandler);
  //     // Initial call to set state correctly based on initial zoom
  //     zoomHandler();

  //     // Return a cleanup function to remove the listeners
  //     return () => {
  //       if (map_instance.isStyleLoaded()) {
  //         map_instance.off("zoom", zoomHandler);
  //         map_instance.off("move");
  //         map_instance.off("moveend");
  //       }
  //     };
  //   };

  //   const cleanup_listeners = setup_map_listeners(map_object);

  //   return cleanup_listeners;
  // }, [layer.map_object, on_get_features_by_bound]);

  const {
    latitude_selected,
    longitude_selected,
    fields_selected,
    properties_selected,
    type_2_selected,
    feature_key_selected,
    geo_layer_selected,
    genangan_cm_selected,
  } = layer;

  const { projection, legend_status } = properties;

  return (
    <>
      <LAYER_SEARCH />

      <main
        id="map_object"
        style={{
          backgroundColor: projection === "globe" ? "#000" : "#efefef",
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          touchAction: "none", // add this
        }}
      />

      <DRAW_GEO />

      {map_object && (
        <>
          <MARKER_GEO />
          <SYMBOL_GEO />
          <LAYER_GEO />
          <LAYER_HEATMAP />
          <LAYER_TOOLBOX />
          <LAYER_GPS />
          <LAYER_INSIGHT />
          <M_S_LOADING />
          <LAYER_S_CENTER />
          <LAYER_S_POI />
          <LAYER_S_POI_PROPERTY />
          <LAYER_S_ISOCHRONE />
          <LAYER_S_DEMOGRAPHY_LIST />
          <LAYER_S_LANDVALUE />
          <LAYER_S_LANDVALUE_NEIGHBOR />
          <LAYER_S_LANDZONE />
          <LAYER_S_LANDZONE_NEIGHBOR />
          <LAYER_S_RDTR_ONE />
          <LAYER_S_RDTR_NEIGHBOR />
          <LAYER_S_POI_SURVEY_1 />
          <LAYER_S_FLOOD_NEIGHBOR />
          <LAYER_S_LANDSLIDE_NEIGHBOR />
          <LAYER_S_TSUNAMI_NEIGHBOR />
          <LAYER_FEATURE_SELECTED />
          <LAYER_TOOLBOX_GRID />
          {legend_status && <LEGEND_PARENT />}
          <POPUP_EDITOR
            latitude_selected={latitude_selected}
            longitude_selected={longitude_selected}
            fields_selected={fields_selected}
            properties_selected={properties_selected}
            type_2_selected={type_2_selected}
            feature_key_selected={feature_key_selected}
            genangan_cm_selected={genangan_cm_selected}
            geo_layer_selected={geo_layer_selected}
            is_editable={is_editable}
          />

          <LAYER_FLOOD_SERVER />
          <LAYER_EXTRUDE_DEM />
          <LAYER_EXTRUDE_FLOOD />
          <FLOOD_NEW />

          <LIBRE_GLB />

          <LAYER_ACTIVITIES_APP />
          <LAYER_PROPERTY_APP />

          <MAP_CONTROL />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_layer,
  set_value_sini,
  get_features_by_bound,
})(MAP_COMPONENT);
